import React, { ReactElement } from 'react';
import { useSessionUserContext } from '../../../../../../../../hooks/use-session-user-context';
import { ConnectedDCloudAnyConnect } from './dCloudContainer';
import { ConnectedPublicAnyConnect } from './publicContainer';

export function AnyConnectContainer(): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();

  if (accessKey) {
    return (
      <ConnectedPublicAnyConnect
        accessKey={accessKey}
        sessionUid={sessionUid}
        versionUid={versionUid}
      />
    );
  }

  return (
    <ConnectedDCloudAnyConnect
      sessionUid={sessionUid}
      versionUid={versionUid}
    />
  );
}

export type AnyConnectProps = {
  anyConnectNode?: AnyConnectNode;
  isLoading: boolean;
  isError: boolean;
};
